module.exports = __webpack_public_path__ + "media/images/country_flags/tw-da4cdf0cfd0622afc07ad0616af7051d.png";